import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, map, take } from 'rxjs';

import {
  getCurrentUser,
  getUserRole,
} from '../store/auth-state/auth.selectors';

import {
  getDashboardRoute,
  normalizeDashboardRole,
} from '../utils/dashboard-role.util';

export const dashboardRedirectGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return combineLatest({
    role: store.select(getUserRole),
    currentUser: store.select(getCurrentUser),
  }).pipe(
    take(1),
    map(({ role, currentUser }) => {
      const directRole = normalizeDashboardRole(role);

      const originRole = normalizeDashboardRole(
        currentUser?.roles?.[0]?.origin_created_by
      );

      const resolvedRole = directRole ?? originRole;

      if (!resolvedRole) {
        return router.createUrlTree(['/forbidden']);
      }

      return router.parseUrl(
        getDashboardRoute(resolvedRole)
      );
    })
  );
};